import { useEffect, useRef, useState } from "react";
import Button from "../../../../Custom/Button/Button";
import { useGlobalContext } from "../../../../../Context/Context";
import CustomSelectSimple from "../../evidencije/CustomSelectSimple";
import CustomCalendarInput from "../../evidencije/CustomCalendarInput";
import EditModal from "./EditModal";
import FullScreenLoader from "../../../FullScreenLoader/FullScreenLoader";

const vrsteUputaAll = ["PRETHODNI", "PERIODICNI", "CILJANI"];

const nowDate = new Date()
  .toLocaleDateString("sr-RS", {
    day: "2-digit",
    month: "2-digit",
    year: "2-digit"
  })
  .replaceAll("/", ".")
  .slice(0, -1);

const emptyGeneralData = {
  radnoMesto: {
    id: -1,
    name: ""
  },
  zaposlen: { id: -1, name: "" },
  vrsta: { id: -1, name: "" }
};
const emptyDocument = {
  ...emptyGeneralData,
  vrstaUputa: "",
  datum: nowDate,
  brojUputa: "",
  mestoRodjenja: "",
  opis: "",
  rizici: "",
  dodatniUslovi: ""
};

const mappingModalKey = {
  OPIS: "opis",
  RIZICI: "rizici",
  DODATNI_USLOVI: "dodatniUslovi"
};

const styles = {
  button: {
    padding: "5px 30px",
    fontWeight: "bold"
  },
  btnModal: {
    padding: "0 10px",
    width: "10vw",
    height: "50px",
    fontWeight: "bold"
  }
};

function UputZaLekarskiForm({ fileNewDocument, generalData, setGeneralData }) {
  const [dokument, setDokument] = useState(emptyDocument);
  const [isDodajNoviText, setIsDodajNoviText] = useState(false);
  const [fileDocument, setFileDocument] = useState(fileNewDocument);
  // "OPIS"/"RIZICI"/"DODATNI_USLOVI"
  const [openModal, setOpenModal] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const fileInputRef = useRef();

  const { dictionary, setIsGlobalnoDodavanjeDokumenta } = useGlobalContext();

  useEffect(() => {
    setDokument((prev) => ({
      ...prev,
      ...generalData,
      opis: generalData.radnoMesto.opis,
      rizici: generalData.radnoMesto.rizici
    }));
  }, [generalData]);

  useEffect(() => {
    setFileDocument(fileNewDocument);
  }, [fileNewDocument]);

  const onChange = (newValue, field) => {
    setDokument((prev) => ({ ...prev, [field]: newValue }));
  };

  const handleFileInputChange = (e) => {
    const file = e.target.files[0];
    if (!file) {
      return;
    }
    setFileDocument(file);
    setIsDodajNoviText(false);
  };

  const handleSave = () => {
    console.log(fileDocument);
    console.log(dokument);

    setIsLoading(true);
    setIsDodajNoviText(true);
    setGeneralData((prev) => ({ ...emptyGeneralData, vrsta: prev.vrsta }));
    setDokument((prev) => ({
      ...emptyDocument,
      vrsta: prev.vrsta,
      vrstaUputa: prev.vrstaUputa,
      opis: generalData.radnoMesto.opis,
      rizici: generalData.radnoMesto.rizici
    }));
    setIsLoading(false);
  };

  const handleDodajNovi = () => {
    fileInputRef.current.value = "";
    fileInputRef.current.click();
  };

  const handleOdustani = () => {
    setIsGlobalnoDodavanjeDokumenta(false);
  };

  const handleOpenModal = (key) => {
    setOpenModal(key);
  };

  const handleCancelModal = () => {
    setOpenModal("");
  };

  // key: "OPIS"/"RIZICI"/"DODATNI_USLOVI"
  const handleConfirmEditModal = (newData, key) => {
    onChange(newData, mappingModalKey[key]);
    handleCancelModal();
  };

  const isDisabledSacuvaj =
    !dokument.radnoMesto.name ||
    !dokument.zaposlen.name ||
    !dokument.vrsta.name ||
    !dokument.vrstaUputa ||
    !dokument.brojUputa ||
    !dokument.mestoRodjenja ||
    !dokument.opis ||
    !dokument.rizici ||
    !dokument.dodatniUslovi;

  if (isLoading) return <FullScreenLoader />;

  return (
    <>
      <CustomSelectSimple
        label={dictionary["vrstaUputa"]}
        allValues={vrsteUputaAll}
        selectedValue={dokument.vrstaUputa}
        onSelectChange={(value) => onChange(value, "vrstaUputa")}
      />
      <div>
        <CustomCalendarInput
          label="DATUM"
          value={dokument.datum}
          onChange={(value) => onChange(value, "datum")}
          style={{ width: "unset" }}
        />
      </div>
      <div
        style={{
          flexBasis: "100%",
          display: "flex",
          gap: "10px",
          alignItems: "flex-end"
        }}
      >
        <div>
          <div
            style={{
              fontWeight: "bold",
              fontSize: "16px",
              marginBottom: "5px"
            }}
          >
            {dictionary["brojUputa"]}
          </div>
          <input
            value={dokument.brojUputa}
            onChange={(e) => onChange(e.target.value, "brojUputa")}
            style={{ height: "40px", padding: "10px", fontSize: "16px" }}
          />
        </div>
        <div>
          <div
            style={{
              fontWeight: "bold",
              fontSize: "16px",
              marginBottom: "5px"
            }}
          >
            {dictionary["mestoRodjenja"]}
          </div>
          <input
            value={dokument.mestoRodjenja}
            onChange={(e) => onChange(e.target.value, "mestoRodjenja")}
            style={{ height: "40px", padding: "10px", fontSize: "16px" }}
          />
        </div>
        <div
          onClick={() => handleOpenModal("OPIS")}
          style={{ opacity: dokument.radnoMesto.name ? 1 : 0.5 }}
        >
          <Button
            isDisabled={!dokument.radnoMesto.name}
            active={openModal === "OPIS"}
            style={styles.btnModal}
          >
            {dictionary["opis"]}
          </Button>
        </div>
        <div
          onClick={() => handleOpenModal("RIZICI")}
          style={{ opacity: dokument.radnoMesto.name ? 1 : 0.5 }}
        >
          <Button
            isDisabled={!dokument.radnoMesto.name}
            active={openModal === "RIZICI"}
            style={styles.btnModal}
          >
            {dictionary["rizici"]}
          </Button>
        </div>
        <div onClick={() => handleOpenModal("DODATNI_USLOVI")}>
          <Button
            active={openModal === "DODATNI_USLOVI"}
            style={styles.btnModal}
          >
            {dictionary["dodatniUslovi"]}
          </Button>
        </div>
      </div>
      <div
        style={{
          flexBasis: "100%",
          display: "flex",
          justifyContent: "flex-end",
          gap: "10px",
          marginTop: "20px"
        }}
      >
        <div onClick={handleOdustani}>
          <Button activation={true} style={styles.button}>
            {dictionary["odustani"]}
          </Button>
        </div>
        <div
          onClick={isDodajNoviText ? handleDodajNovi : handleSave}
          style={{ opacity: !isDodajNoviText && isDisabledSacuvaj ? 0.5 : 1 }}
        >
          <input
            type="file"
            ref={fileInputRef}
            style={{ display: "none" }}
            onChange={handleFileInputChange}
          />
          <Button
            isDisabled={!isDodajNoviText && isDisabledSacuvaj}
            activation={true}
            style={styles.button}
          >
            {isDodajNoviText ? "+ DODAJ NOVI" : dictionary["sacuvaj"]}
          </Button>
        </div>
      </div>

      {openModal && (
        <EditModal
          handleCancel={handleCancelModal}
          handleConfirm={handleConfirmEditModal}
          initialData={dokument[mappingModalKey[openModal]]}
          modalKey={openModal}
        />
      )}
    </>
  );
}

export default UputZaLekarskiForm;
